import {get} from 'lodash';
import {isNil} from 'lodash/fp';

import {getTaskNameForTealium} from '/component/screen/ClientProfile/ClientJourney/ClientJourneyTask.util';
import {FILTER_TYPES, SCREEN_NAMES, USER_TYPES} from '/enum/tealium.enum';

export const onRefresh = (refreshing, resetCandidatesData) => {
  refreshing = true;
  resetCandidatesData();
  setTimeout(() => {
    refreshing = false;
  }, 200);
};

export const generateOnPress = ({
  sendEvent,
  personIsCoach,
  item,
  reportName,
  clientMilestone,
  onRecordPress,
  isPeopleToContactSection,
  isCandidateReport,
  screenName,
  lastPaidRank,
}: any) => {
  return () => {
    if (isPeopleToContactSection && !isCandidateReport) {
      // when there is a next task in people to contact, currentScreenName is passed with the value 'clients-to-contacts',
      // and  clientMilestone is passed with one of the clientJourney task name as a value

      sendEvent({
        userType: personIsCoach(item) ? USER_TYPES.coach : USER_TYPES.client,
        userId: item.id,
        userFullName: item.firstName + ' ' + item.lastName,
        ...(!item?.nextTask && {
          previousScreenName: screenName,
        }),
        ...(Object.values(FILTER_TYPES).includes(clientMilestone) && {
          currentScreenName: SCREEN_NAMES.clientsToContact,
        }),
        clientMilestone:
          clientMilestone === FILTER_TYPES.nextTask
            ? getTaskNameForTealium(item?.nextTask)
            : clientMilestone,
        lastPaidRank: lastPaidRank,
      });
    } else if (isCandidateReport && reportName === 'REPORT_ALL_CANDIDATES') {
      sendEvent({
        userType: USER_TYPES.candidate,
        userId: item.prospectInfoId,
        userFullName: item.name,
        screenName: isPeopleToContactSection ? screenName : reportName,
        lastPaidRank: lastPaidRank,
      });
    } else if (!(isCandidateReport && reportName === 'REPORT_ALL_REFERRALS')) {
      // Skip firing profileClick for REPORT_ALL_REFERRALS as AllReferralsContent.tsx handles this more specifically
      sendEvent({
        userType: personIsCoach(item) ? USER_TYPES.coach : USER_TYPES.client,
        userId: item.id,
        userFullName: item.firstName + ' ' + item.lastName,
        screenName: reportName,
        lastPaidRank: lastPaidRank,
      });
    }
    onRecordPress(item, reportName);
  };
};

/**
 *This function checks if an alternateItemKey exists. If it does, it gets that key from the item object else it returns the items id.
 * @param {alternateItemKey} string - alternateItemKey field name. In this case 'uniqueId'
 * @returns {function(*): *} - returns a function that gets a key from an object.
 */
export const getKeyExtractor = ({alternateItemKey}: any) => {
  if (!isNil(alternateItemKey)) {
    return (item: any) => item[alternateItemKey];
  }
  return (item: any) => item?.id;
};

/**
 * This function get avatarUrl from the object from the props
 * @param {object} params - Parameters
 * @returns {string}
 */
export const getPersonAvatarUrl = (item: any) => get(item, 'avatarUrl', '');

/**
 * This function get accountEmail from the object from the props
 * @param {object} params - Parameters
 * @returns {string | null}
 */
export const getPersonAvatarEmail = (item: any) =>
  get(item, 'accountEmail', null);
